import {ACTIVITIES_DATA, CONVERSATION_STATS, HOME_USERS_ANALYTICS} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case CONVERSATION_STATS:
      return {
        ...state,
        conversationStatsData: action.payload,
      }

    case HOME_USERS_ANALYTICS:
      return {
        ...state,
        homeUserAnalyticsData: action.payload,
      }

    case ACTIVITIES_DATA:
      return {
        ...state,
        activitiesData: action.payload,
      }
    default:
      return state
  }
}
